import parse from 'html-react-parser'
import Image from 'next/image'
import Link from 'next/link'
import Script from 'next/script'

import Header from '../../components/header'
import Footer from '../../components/footer'
import MiniCart from '../../components/cart/minicart'
import Noresults from '../../components/noresults';
import Scripts from '../../components/scripts';
import MetaTags from '../../components/MetaTags'

function LandingPage({ item, menu, config }) {

    return (
        <>
            <MetaTags item={item} config={config}></MetaTags>
            <div className="wrapper h-full flex flex-col">
                <Header menu={menu} config={config}></Header>
                <section className="content flex flex-grow flex-col">
                    <div className="hidden lg:block">
                        <div className="container mx-auto text-xs py-2 px-5 lg:px-0">
                            <div className="space-x-2 flex items-center leading-none">
                                <Link href="/">
                                    <a className="cursor-pointer">
                                        <i className="fas fa-home"></i>
                                    </a>
                                </Link>
                                <span className="text-gray-500">/</span>
                                <Link href="/blog">
                                    <a className="cursor-pointer text-gray-900 underline">
                                        Blog
                                    </a>
                                </Link>
                                <span className="text-gray-500">/</span>
                                <span className="text-gray-500">{item.name}</span>
                            </div>
                        </div>
                    </div>
                    {(item && item.description) ? (
                        <>
                            <div className="py-8 lg:py-16">
                                <div className="container mx-auto lg:mb-4">

                                    <div className="xl:w-1/2 px-5 lg:px-0 mx-auto">
                                        <div className="text-brand-primary text-xs font-semibold lg:text-center uppercase mb-2">{item.taxonomies[0] ? item.taxonomies[0].name:''}</div>
                                        <h1 className="h1 lg:text-center mb-2">{item.name}</h1>
                                        <div className="text-gray-500 text-xs font-medium mb-8 lg:text-center">
                                            {new Date(item.created_at).toLocaleDateString(
                                                'en-gb',
                                                {
                                                    year: 'numeric',
                                                    month: 'long',
                                                    day: 'numeric'
                                                }
                                            )}
                                        </div>
                                    </div>

                                    <div className="xl:w-8/12 mx-auto">
                                        {(item && item.media && item.media[0] && item.media[0].original_url) ? (
                                            <>
                                                <Image
                                                    src={item.media[0].original_url}
                                                    alt={item.name}
                                                    width="1024"
                                                    height="380"
                                                    className="w-full lg:rounded-lg"
                                                    placeholder="blur"
                                                    layout="responsive"
                                                    blurDataURL="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mP8Xw8AAoMBgDTD2qgAAAAASUVORK5CYII="
                                                />
                                            </>
                                        ) : (
                                            <>
                                                <Image
                                                    src={process.env.NEXT_PUBLIC_COMING_SOON_IMAGE}
                                                    alt={item.name}
                                                    width="1024"
                                                    height="380"
                                                    className="w-full lg:rounded-lg"
                                                    placeholder="blur"
                                                    blurDataURL="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mP8Xw8AAoMBgDTD2qgAAAAASUVORK5CYII="
                                                />
                                            </>
                                        )}
                                    </div>

                                    <div className="relative xl:w-8/12 mx-auto mt-8 px-5 lg:px-0">

                                        <div className="lg:w-1/12 mb-6">
                                            <Script async defer crossorigin="anonymous" src="https://connect.facebook.net/en_US/sdk.js#xfbml=1&version=v13.0" nonce="VOizzfLh" />
                                            <div className="social-icons-share lg:flex lg:flex-col lg:absolute lg:left-0 lg:top-0 lg:space-y-4 lg:items-center">
                                                <div className="text-xs text-gray-600 font-semibold mb-2">SHARE</div>
                                                <div className="flex lg:flex-col lg:space-y-2 lg:space-x-0 space-x-3 lg:items-center">
                                                    <div className="fb-share-button" data-href={window.location.href} data-layout="button_count" data-size="small">
                                                        <a
                                                            rel="noreferrer" target="_blank"
                                                            href={"https://www.facebook.com/sharer/sharer.php?u=" + window.location.href}
                                                            className="fb-xfbml-parse-ignore"
                                                        >
                                                            <i className="icon icon-facebook-dark w-6 h-6"></i>
                                                        </a>
                                                    </div>
                                                    <a
                                                        rel="noreferrer" target="_blank"
                                                        href={"https://www.linkedin.com/shareArticle?mini=true&url=" + window.location.href + "&title=" + item.name + "&summary=" + item.name}
                                                    >
                                                        <i className="icon icon-linkedin-dark w-6 h-6"></i>
                                                    </a>
                                                    <a rel="noreferrer" target="_blank" className="twitter-share-button" href="https://twitter.com/intent/tweet">
                                                        <i className="icon icon-twitter-dark w-6 h-6"></i>
                                                    </a>
                                                    <a href="whatsapp://send?text=" data-action="share/whatsapp/share" ><i className="fab fa-whatsapp text-gray-600 text-3xl align-middle"></i></a>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="lg:w-8/12 mx-auto">
                                            {parse(item.description)}
                                        </div>

                                    </div>

                                </div>
                            </div>
                        </>
                    ) : (
                        <Noresults></Noresults>
                    )}
                </section>
                <Footer menu={menu} config={config}></Footer>
            </div>
            <MiniCart></MiniCart>
            <Scripts javascripts={item.javascripts}></Scripts>
        </>
    )
}


// This function gets called at build time on server-side.
// It may be called again, on a serverless function, if
// revalidation is enabled and a new request comes in
export async function getStaticProps(context) {
    const config_res = await fetch(process.env.NEXT_PUBLIC_API_URL + '/configs')
    const config_data = await config_res.json()
    const config = config_data.data

    const menu_res = await fetch(process.env.NEXT_PUBLIC_API_URL + '/menu')
    const menu = await menu_res.json()

    const res = await fetch(process.env.NEXT_PUBLIC_API_URL + '/blog/' + context.params.url)
    const response = await res.json()
    const item = (response.status) ? (response.data) : (false)


    if (!item) {
        return {
            notFound: true
        }
    }

    return {
        props: {
            config: config,
            menu: menu,
            item: item,
        },
        // Next.js will attempt to re-generate the page:
        // - When a request comes in
        // - At most once every 10 seconds
        revalidate: 600, // In seconds

    }
}

// This function gets called at build time on server-side.
// It may be called again, on a serverless function, if
// the path has not been generated.
export async function getStaticPaths() {
    const res = await fetch(process.env.NEXT_PUBLIC_API_URL + '/blog')
    const response = await res.json()
    const items = response.data.data

    // Get the paths we want to pre-render based on products
    const paths = items.map((item) => ({
        params: {
            url: item.url.toString(),
        },
    }))

    // We'll pre-render only these paths at build time.
    // { fallback: blocking } will server-render pages
    // on-demand if the path doesn't exist.
    return { paths, fallback: 'blocking' }
}


export default LandingPage